const styles = (theme) => ({
  root: {
    width: "100%",
    height: "75px",
    padding: theme.hv.spacing.sm,
    borderTop: `3px solid ${theme.hv.palette.atmosphere.atmo2}`,
    display: "flex",
    justifyContent: "flex-end",
  },
});

export default styles;
